import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <p className='footer__text'>Created By Hashim Alzubi</p>
  </footer>
)

export default Footer

